import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    padding: ", ";\n    color: #333333;\n    font-family: Lato, sans-serif;\n    font-size: 16px;\n    line-height: 24px;\n\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  font-family:proxima-nova, sans-serif;\n  font-size: 12px;\n  font-weight: 200;\n  line-height: 24px;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useRef } from 'react';
import styled from 'styled-components';
import { useFocus } from '../../shared';
import { legacySwappable } from '../../theme';
var baseCss = "\n  list-style: none;\n  outline: none;\n  cursor: pointer;\n";

var OptionComponent = function OptionComponent(_ref) {
  var _native = _ref["native"],
      forwardedAs = _ref.forwardedAs,
      isFocused = _ref.isFocused,
      active = _ref.active,
      other = _objectWithoutProperties(_ref, ["native", "forwardedAs", "isFocused", "active"]);

  var itemRef = useRef();
  useFocus(itemRef, {
    shouldFocus: active && isFocused
  });
  var Component = _native ? 'option' : forwardedAs || 'li';
  return /*#__PURE__*/React.createElement(Component, _extends({}, other, {
    ref: itemRef,
    tabIndex: other.selected ? 0 : -1,
    role: "option",
    "aria-selected": other.selected,
    "aria-disabled": false,
    "data-value": other.value
  }));
}; // Legacy theme


var LegacyOption = styled(OptionComponent)(_templateObject(), baseCss, function (_ref2) {
  var active = _ref2.active;
  return active && 'background: #eeeeee;';
}); // END legacy theme

var Option = legacySwappable(LegacyOption, styled(OptionComponent)(_templateObject2(), baseCss, function (p) {
  return p.theme.spacing(2, 6);
}, function (_ref3) {
  var active = _ref3.active,
      theme = _ref3.theme;
  return active && "background: ".concat(theme.grey6, ";");
}));
export default Option;